import { render, staticRenderFns } from "./editArticleType.vue?vue&type=template&id=bc5b629c&scoped=true&"
import script from "./editArticleType.vue?vue&type=script&lang=js&"
export * from "./editArticleType.vue?vue&type=script&lang=js&"
import style0 from "./editArticleType.vue?vue&type=style&index=0&id=bc5b629c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc5b629c",
  null
  
)

export default component.exports